/**
 * The one sentence a refused sign-in comes back with.
 *
 * The API redirects with a reason code (`?auth_error=`), never a message: a
 * message in an address is a message anyone can forge into a link. Only the
 * codes below are shown; anything else reads as the plain fallback.
 */
const MESSAGES: Readonly<Record<string, string>> = {
  google_not_configured:
    "Google sign-in is not set up on this server yet. If you have a password, use it below.",
  google_cancelled: "Google sign-in was cancelled. Try again when you are ready.",
  google_state_mismatch: "That sign-in could not be matched to this browser. Try again.",
  google_flow_missing:
    "That sign-in took too long or started in another browser. Try again.",
  google_email_unverified:
    "Google has not verified that email address, so we cannot use it to sign you in.",
  google_account_mismatch:
    "This email is already tied to a different Google account. Sign in with that one.",
  google_code_rejected: "Google did not accept that sign-in. Try again.",
  login_link_no_account: "That link is for an account that does not exist.",
};

const FALLBACK = "That sign-in did not work. Try again.";

/** The sentence for this address's `auth_error`, or null when there is none. */
export function authErrorFrom(params: URLSearchParams): string | null {
  const code = params.get("auth_error");
  if (code === null) return null;
  return MESSAGES[code] ?? FALLBACK;
}
